/**
 * Copia el cookie de tracking de Exponea/Bloomreach (__exponea_etc__) como
 * atributo oculto en cualquier formulario de "agregar al carro" / "comprar
 * ahora" de la tienda, para que viaje junto con el carrito hasta el checkout
 * (donde la extension KC Cross-Sell lo usa para pedir recomendaciones
 * personalizadas). No hace ninguna llamada de red -- solo lee una cookie que
 * ya existe y escribe un campo de formulario.
 *
 * Cubre tanto "Agregar al carro" (que pasa por el carrito) como "Comprar
 * ahora" / compra directa desde la PDP (que salta el carrito), porque ambos
 * usan el mismo formulario de producto.
 *
 * IMPORTANTE: el valor se rellena en 2 momentos:
 *  1. Al cargar la pagina / cuando aparecen formularios nuevos (mejor esfuerzo).
 *  2. JUSTO ANTES de que el formulario se envie (listener en fase de captura,
 *     corre antes que el handler propio del theme) -- esto es lo que
 *     garantiza el valor correcto, porque el SDK de Exponea puede tardar en
 *     crear su cookie, y para cuando el cliente hace click ya tuvo tiempo de
 *     inicializarse.
 */
(function () {
  var COOKIE_NAME = "__exponea_etc__";
  var ATTRIBUTE_NAME = "attributes[bloomreach_cookie]";

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)")
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function injectIntoForm(form, value) {
    var input = form.querySelector('input[name="' + ATTRIBUTE_NAME + '"]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = ATTRIBUTE_NAME;
      form.appendChild(input);
    }
    input.value = value;
    return input;
  }

  function isCartAddForm(form) {
    return !!(form && form.tagName === "FORM" && (form.action || "").indexOf("/cart/add") !== -1);
  }

  function syncAllForms() {
    var cookieValue = getCookie(COOKIE_NAME);
    if (!cookieValue) return;

    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      injectIntoForm(forms[i], cookieValue);
    }
  }

  // 1. Mejor esfuerzo al cargar la pagina...
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncAllForms);
  } else {
    syncAllForms();
  }

  // ...y de nuevo cada vez que se agregan formularios nuevos al DOM
  // (quick-add, modales, secciones cargadas por AJAX, etc.)
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        syncAllForms();
        break;
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // 2. Garantia: justo antes de enviar CUALQUIER formulario de agregar al
  // carro, se rellena con el valor mas fresco posible de la cookie. Fase de
  // captura para correr ANTES que el listener propio del theme (que hace
  // evt.preventDefault() y arma su propio FormData).
  document.addEventListener(
    "submit",
    function (evt) {
      if (!isCartAddForm(evt.target)) return;
      var cookieValue = getCookie(COOKIE_NAME);
      if (cookieValue) injectIntoForm(evt.target, cookieValue);
    },
    true
  );
})();
